import { FilterWrapper } from '../../shared/components/FilterWrapper/FilterWrapper'

export const Filter = () => {
  return (
    <>
      <FilterWrapper></FilterWrapper>
    </>
  )
}
